import { defineComponent as _defineComponent } from 'vue'
import OfferCardMain from "@/components/offers/offer/OfferCardMain.vue";
import OfferCardLogo from "@/components/offers/offer/OfferCardLogo.vue";
import OfferCardTracking from "@/components/offers/offer/OfferCardTracking.vue";
import OfferCardCategory from "@/components/offers/offer/OfferCardCategory.vue";
import OfferCardTargeting from "@/components/offers/offer/OfferCardTargeting.vue";
import OfferCardGoals from "@/components/offers/offer/OfferCardGoals.vue";
import OfferCardPlannedChanges from "@/components/offers/offer/OfferCardPlannedChanges.vue";
import OfferCardNotes from "@/components/offers/offer/OfferCardNotes.vue";
import OfferCardSettings from "@/components/offers/offer/OfferCardSettings.vue";
import OfferCardErid from "@/components/offers/offer/OfferCardErid.vue";
import Loader from "@/components/base/Loader.vue";
import OfferCardTableMetrics from "@/components/offers/offer/metrics/OfferCardTableMetrics.vue";
import { OfferSingle } from "@/services/offers/OfferSingle";
import { computed, ref } from "vue";
import { useWindowResize } from "@/utils/useWindowSize";
import TaskOnTargetDetail from "@/components_v3/tasks/TaskOnTargetDetail.vue";

interface Props {
    offer: OfferSingle;
}

interface OfferCard {
    component: any;
    isHide?: boolean;
    props?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferMain',
  props: {
    offer: null
  },
  emits: ['edit-goal', 'update-offer'],
  setup(__props: any, { emit }) {

const props = __props as {
    offer: OfferSingle;
}



const isLoading = ref(false);
const { width } = useWindowResize();

const isOfferEmpty = computed(() => {
    return Object.keys(props.offer).length <= 0;
});

const isDesktop = computed(() => {
    return width.value > 1264;
});

const desktopLeftCol: OfferCard[] = [
    { component: OfferCardMain },
    { component: OfferCardLogo },
    { component: OfferCardSettings },
    { component: OfferCardTracking },
    { component: OfferCardCategory },
    { component: OfferCardTargeting },
];

const desktopRightCol: OfferCard[] = [
    { component: OfferCardPlannedChanges, isHide: props.offer.planned_changes.length <= 0 },
    { component: OfferCardTableMetrics },
    { component: OfferCardGoals },
    { component: OfferCardErid, isHide: !props.offer.erid.id },
    { component: TaskOnTargetDetail, props: { target: 'offer', targetId: props.offer.legacy_id, managerId: props.offer.manager?.legacy_id } },
    { component: OfferCardNotes },
];

const mobileCol: OfferCard[] = [
    { component: OfferCardMain },
    { component: OfferCardPlannedChanges, isHide: props.offer.planned_changes.length <= 0 },
    { component: OfferCardTableMetrics },
    { component: OfferCardLogo },
    { component: OfferCardErid, isHide: !props.offer.erid.id },
    { component: OfferCardGoals },
    { component: OfferCardSettings },
    { component: OfferCardTracking },
    { component: OfferCardCategory },
    { component: OfferCardTargeting },
    { component: TaskOnTargetDetail, props: { target: 'offer', targetId: props.offer.legacy_id, managerId: props.offer.manager?.legacy_id } },
    { component: OfferCardNotes },
];

const getLeftCol = computed<OfferCard[]>(() => isDesktop.value ? desktopLeftCol : mobileCol);


return { __sfc: true,props, emit, isLoading, width, isOfferEmpty, isDesktop, desktopLeftCol, desktopRightCol, mobileCol, getLeftCol, Loader }
}

})